/* eslint-disable  */
/* eslint-disable operator-linebreak */
import React from 'react';

import { ReactComponent as EditIcon } from 'src/assets/edit_profile.svg';
import fallbackImageUrl from 'src/assets/empty_photo_benefit.jpg';
import {
  AbsoluteIcon,
  CardContentContainer,
  CardContentTitle,
  CardImgContainer,
  EnrollmentChangesCardContainer,
  FallbackImg,
  IconCardSlot,
} from './styles';
import { IBenefitType } from 'src/interfaces';

import { useNavigate } from 'react-router-dom';

const EnrollmentCardEditAction: React.FC<{
  benefitType: IBenefitType;
}> = ({ benefitType }) => {
  const navigate = useNavigate();

  const onEdit = () => {
    navigate(`/benefits/edit/${encodeURIComponent(benefitType.type)}`, { replace: true });
  };

  return (
    <IconCardSlot data-testid="enroll-modal-button" onClick={() => onEdit()}>
      <AbsoluteIcon>
        <EditIcon />
      </AbsoluteIcon>
    </IconCardSlot>
  );
};

const EnrollmentChangesCard: React.FC<{
  benefitType: IBenefitType;
}> = ({ benefitType }) => {
  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    // eslint-disable-next-line no-param-reassign
    event.currentTarget.src = fallbackImageUrl;
  };

  return (
    <EnrollmentChangesCardContainer>
      <CardImgContainer>
        <FallbackImg src={benefitType.imgURL ?? ''} alt="Fallback Image" onError={handleImageError} />
        <EnrollmentCardEditAction benefitType={benefitType} />
      </CardImgContainer>

      <CardContentContainer>
        <CardContentTitle>{benefitType.type}</CardContentTitle>
      </CardContentContainer>
    </EnrollmentChangesCardContainer>
  );
};

export default EnrollmentChangesCard;
